import React from "react";
import { Badge } from "../ui/badge";
import { Hash, Clock, Star } from "lucide-react";

export function fmtTime(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true });
}

export function waitedMinutes(entry) {
  const from = entry?.checked_in_at || entry?.date_time;
  if (!from) return null;
  const mins = Math.floor((Date.now() - new Date(from).getTime()) / 60000);
  return mins >= 0 ? mins : null;
}

export const STATUS_STYLES = {
  waiting: "bg-slate-50 border-slate-200 text-slate-600",
  called: "bg-blue-50 border-blue-200 text-blue-700",
  in_consultation: "bg-emerald-50 border-emerald-200 text-emerald-700",
  completed: "bg-slate-100 border-slate-200 text-slate-600",
  skipped: "bg-amber-50 border-amber-200 text-amber-700",
  cancelled: "bg-rose-50 border-rose-200 text-rose-700",
};

export const STATUS_LABELS = {
  waiting: "Waiting",
  called: "Called",
  in_consultation: "In consultation",
  completed: "Consultation done",
  skipped: "Skipped",
  cancelled: "Cancelled",
};

export function StatusBadge({ status }) {
  return (
    <Badge variant="outline" className={STATUS_STYLES[status] || STATUS_STYLES.waiting} data-testid={`status-badge-${status}`}>
      {STATUS_LABELS[status] || status}
    </Badge>
  );
}

export function TokenBadge({ entry }) {
  if (entry?.type === "walk_in" || entry?.queue_number) {
    return (
      <Badge variant="outline" className="bg-violet-50 border-violet-200 text-violet-700 gap-1">
        <Hash className="w-3 h-3" /> {entry.queue_number}
      </Badge>
    );
  }
  return (
    <Badge variant="outline" className="bg-blue-50 border-blue-200 text-blue-700 gap-1">
      <Clock className="w-3 h-3" /> {fmtTime(entry?.date_time)}
    </Badge>
  );
}

export function PriorityFlag() {
  return (
    <Badge variant="outline" className="bg-rose-50 border-rose-200 text-rose-700 gap-1" data-testid="priority-flag">
      <Star className="w-3 h-3 fill-rose-500 text-rose-500" /> Priority
    </Badge>
  );
}

export function BillingBadge({ invoice }) {
  if (!invoice) {
    return (
      <Badge variant="outline" className="bg-amber-50 border-amber-200 text-amber-700" data-testid="billing-badge-none">
        No bill
      </Badge>
    );
  }
  const map = {
    paid: "bg-emerald-50 border-emerald-200 text-emerald-700",
    partial: "bg-amber-50 border-amber-200 text-amber-700",
    unpaid: "bg-rose-50 border-rose-200 text-rose-700",
    draft: "bg-slate-50 border-slate-200 text-slate-600",
    cancelled: "bg-slate-100 border-slate-200 text-slate-400",
  };
  const labels = { paid: "Paid", partial: "Partially paid", unpaid: "Unpaid", draft: "Draft", cancelled: "Cancelled" };
  return (
    <Badge variant="outline" className={map[invoice.status] || map.unpaid} data-testid={`billing-badge-${invoice.status}`}>
      {labels[invoice.status] || invoice.status}
    </Badge>
  );
}
